<div style="display: flex; align-items: baseline; flex-direction: column" matSnackBarLabel>
  <div class="main-content d-flex">
    <mat-icon>{{ data.icon }}</mat-icon>
    &nbsp;
    {{ data.message }}
    &nbsp;
  </div>
  <div class="sub-content f-s-10" [innerHTML]="data.submessage"></div>
</div>
@if (data.action) {
  <span matSnackBarActions>
    <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
      {{ data.action }}
    </button>
  </span>
}